import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import util from 'util';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';
import Reactcalendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { CSVLink } from "react-csv";
import { CSVReader } from 'react-papaparse'
import CommonBooking from '../Common/common_booking';
import Loading from '../Loading/Loading';
import Common from '../Common/common';
import constClass from '../../Constants/Constants';

const uploadButtonRef = React.createRef();

const Calendar = (props) => {
  const { settings } = props;
  const Today = new Date();
  const { addToast } = useToasts();
  const [disabled, setDisabled] = useState(false);
  const [selectDate, setSelectDate] = useState(Today);
  const [calendarList, setCalendarList] = useState([]);
  const [calendarMasterList, setCalendarMasterList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [csvData, setCsvData] = useState(null);
  const book_start = moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD')
  const [uploadFile, setUploadFile] = useState({ minDate: null, maxDate: null, list: [] });
  const [selectShop, setSelectShop] = useState(props.user.shopId);
  const [shoplist, setShoplist] = useState([]);
  const [selectDisabled, setSelectDisabled] = useState(true);

  const refreshMaster = useCallback(async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');

    if (selectShop === null) {
      //一番小さいshop_idを取得する
      const setshop = shoplist.reduce((prev, curr) => (prev.shop_id < curr.shop_id) ? prev : curr)
      setSelectShop(setshop.shop_id);
    }

    const params = {
      site_id: props.siteId,
      book_start: book_start,
      shop_id: selectShop,
    }
    if (selectShop !== null) {
      const calendarPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/listalldate/`, params, { headers: { Authorization: `Bearer ${jwt}` } });
      const calendar = (await calendarPromise).data;
      setCalendarList(calendar);
    }
    const holidayPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/holiday/search/`, params);
    const holiday = (await holidayPromise).data;
    setHolidayList(holiday);
  }, [props.siteId, book_start, selectShop, shoplist]);

  const refresCsvdata = useCallback(async () => {
    setDisabled(true);
    //トークンを取得
    const jwt = localStorage.getItem('jwt');
    var head = [];
    var list = [];

    const params = {
      site_id: props.siteId,
      book_start: moment(selectDate).startOf('month').format('YYYY-MM-DD'),
      book_end: moment(selectDate).endOf('month').format('YYYY-MM-DD'),
      shop_id: selectShop,
    }
    const calendarPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/backyard/search/`, params, { headers: { Authorization: `Bearer ${jwt}` } });
    const calendarMaster = (await calendarPromise).data;
    setCalendarMasterList(calendarMaster);

    head.push({ label: "予約日", key: "book_date" });
    head.push({ label: "ID", key: "book_set_id" });
    head.push({ label: "カテゴリーID", key: "category_id" });
    head.push({ label: "開始時刻", key: "start_time" });
    head.push({ label: "終了時刻", key: "end_time" });
    head.push({ label: "受付数", key: "book_count" });
    head.push({ label: "備考", key: "remarks" });
    head.push({ label: "税抜き単価", key: "price_before_tax" });
    head.push({ label: "税込み単価", key: "price" });
    head.push({ label: "税率", key: "tax_rate" });
    list = calendarMaster;
    setCsvData({ header: head, list: list });
    setDisabled(false);
  }, [props.siteId, selectDate, selectShop]);

  const getShoplist = useCallback(async () => {
    // 店舗データを取得
    const params = {
      site_id: props.siteId,
      operator: "and",
      where: [
        { site_id: props.siteId }
      ]
    }
    const jwt = localStorage.getItem('jwt');
    const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/search`, params, { headers: { Authorization: `Bearer ${jwt}` } });
    await setShoplist(result.data);

    //ユーザー権限確認
    if (props.user.userClass === constClass.CLASS.ADMIN) {
      setSelectDisabled(false);
    }

  }, [props.siteId])

  const getTileContent = (a) => {
    const cal = calendarList.find(x => moment(x.book_date).format('YYYYMMDD') === moment(a.date).format('YYYYMMDD'));
    return (
      <p className={`${cal ? "bg-yellow" : ""}`}>
        {cal ? "〇" : "-"}
      </p>
    );
  }

  // state の日付と同じ表記に変換
  const getFormatDate = (date) => {
    return `${date.getFullYear()}${('0' + (date.getMonth() + 1)).slice(-2)}${('0' + date.getDate()).slice(-2)}`;
  }

  const getTileClass = ({ date, view }) => {
    // 月表示のときのみ
    if (view !== 'month') {
      return '';
    }
    const day = getFormatDate(date);
    return (holidayList.findIndex(x => getFormatDate(new Date(x.holiday_date)) === day) >= 0 ? 'holiday' : '');
  }

  const changeDate = (date) => {
    setSelectDate(date)
  }

  const changeSelectShop = (date => {
    setSelectShop(date.target.value);
    refreshMaster();
    refresCsvdata();
  })

  const changeStartDate = (date) => {
    setSelectDate(date.activeStartDate);
  }

  const handleOnDrop = (datalist) => {
    setDisabled(true);
    var list = [];
    var minDate = null;
    var maxDate = null;
    var secondcheck = true;
    var minutecheck = true;
    var remarks = true;
    const regex = /^[0-9]{4}\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])$/;
    const regex1 = /^[0-9]{4}\-(0?[1-9]|1[0-2])\-(0?[1-9]|[12][0-9]|3[01])$/;
    for (let index = 1; index < datalist.length; index++) {
      if (regex.test(datalist[index].data[0]) || regex1.test(datalist[index].data[0])) {
        if (datalist[index].data[3] !== '') {
          datalist[index].data[3] = datalist[index].data[3].toString();
          while (datalist[index].data[3].length < 6) {
            if(datalist[index].data[3].length === 3){
              datalist[index].data[3] = '0' + datalist[index].data[3] + '00';
            }else if(datalist[index].data[3].length === 4){
              datalist[index].data[3] = datalist[index].data[3] + '00';
            }else if(datalist[index].data[3].length === 5){
              datalist[index].data[3] = '0' + datalist[index].data[3]
            }else{
              datalist[index].data[3] = datalist[index].data[3] + '0';
            }
          }
          if (Number(datalist[index].data[3].substr(2, 2)) >= 60) {
            secondcheck = false;
          }
          if (Number(datalist[index].data[3].substr(4, 2)) >= 60) {
            minutecheck = false;
          }
        }
        if (datalist[index].data[4] !== '') {
          datalist[index].data[4] = datalist[index].data[4].toString();
          while (datalist[index].data[4].length < 6) {
            if(datalist[index].data[4].length === 3){
              datalist[index].data[4] = '0' + datalist[index].data[4] + '00';
            }else if(datalist[index].data[4].length === 4){
              datalist[index].data[4] = datalist[index].data[4] + '00';
            }else if(datalist[index].data[4].length === 5){
              datalist[index].data[4] = '0' + datalist[index].data[4]
            }else{
              datalist[index].data[4] = datalist[index].data[4] + '0';
            }
          }
          if (Number(datalist[index].data[4].substr(2, 2)) >= 60) {
            secondcheck = false;
          }
          if (Number(datalist[index].data[4].substr(4, 2)) >= 60) {
            minutecheck = false;
          }
        }
        if (datalist[index].data[6].length > 100) {
          remarks = false;
        }
        var d = {
          site_id: props.siteId,
          book_date: datalist[index].data[0],
          book_set_id: datalist[index].data[1],
          category_id: datalist[index].data[2],
          start_time: datalist[index].data[3],
          end_time: datalist[index].data[4],
          book_count: datalist[index].data[5],
          remarks: datalist[index].data[6],
          price_before_tax: datalist[index].data[7],
          price: datalist[index].data[8],
          tax_rate: datalist[index].data[9],
          shop_id: selectShop,
        }
        if (minDate === null || moment(minDate) > moment(datalist[index].data[0])) minDate = datalist[index].data[0];
        if (maxDate === null || moment(maxDate) < moment(datalist[index].data[0])) maxDate = datalist[index].data[0];
        list.push(d);
      }
    }
    if (minDate === null || maxDate === null) {
      alert("アップロードされたファイルが正常に読み込めませんでした。");
      if (uploadButtonRef.current) {
        uploadButtonRef.current.removeFile();
      }
    } else if (secondcheck === false) {
      alert("開始時刻または終了時刻の分の値は００～５９までで、入力してください。");
      if (uploadButtonRef.current) {
        uploadButtonRef.current.removeFile();
      }
    } else if (minutecheck === false) {
      alert("開始時刻または終了時刻の秒の値は００～５９までで、入力してください。");
      if (uploadButtonRef.current) {
        uploadButtonRef.current.removeFile();
      }
    }
    else if (remarks === false) {
      alert("備考は、100文字以内で入力してください。");
      if (uploadButtonRef.current) {
        uploadButtonRef.current.removeFile();
      }
    } else {
      setUploadFile({ minDate, maxDate, list });
    }
    setDisabled(false);
  };

  const handleOnRemoveFile = () => {
    setUploadFile({ minDate: null, maxDate: null, list: [] });
  }

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  const submit = async () => {
    setDisabled(true);
    //トークンを取得
    const jwt = localStorage.getItem('jwt');
    try {
      if (!window.confirm('登録しますか？')) {
        setDisabled(false);
        return;
      }
      var res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/`, { site_id: props.siteId, shop_id: selectShop, minDate: uploadFile.minDate, maxDate: uploadFile.maxDate, list: uploadFile.list }, { headers: { Authorization: `Bearer ${jwt}` } });
      //console.log(res)
      if (res.data && res.data.result) {
        addToast(`登録しました`, { appearance: 'success', autoDismiss: true });
        setUploadFile({ minDate: null, maxDate: null, list: [] });
        refreshMaster();
      } else {
        alert(`登録に失敗しました\n${res.data && res.data.message ? res.data.message : ""}`);
      }
      setUploadFile({ minDate: null, maxDate: null, list: [] });
      refreshMaster();
      if (uploadButtonRef.current) {
        uploadButtonRef.current.removeFile();
      }

    } catch (error) {
      console.log(util.inspect(error))
      const err_message = error.response && error.response.data && error.response.data.message ? error.response.data.message : "";
      alert(`登録に失敗しました\n${err_message}`);
      if (uploadButtonRef.current) {
        uploadButtonRef.current.removeFile();
      }
    }
    setDisabled(false);
  }

  useEffect(() => {
    getShoplist();
  }, [getShoplist]);
  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);
  useEffect(() => {
    refresCsvdata();
  }, [refresCsvdata]);

  return (selectShop != null &&
    <div className="container">
      <div className='col pt-2 pb-2'>
        <h5>支所名</h5>
        <select className="custom-select w-100 text-center" aria-label="カテゴリ"
          value={selectShop}
          onChange={changeSelectShop}
          disabled={selectDisabled}>
          {shoplist.map((item, idx) =>
            <option key={idx} value={item.shop_id}>{item.shop_name}</option>
          )}
        </select>
      </div>
      <div className='row'>
        <div className='col-4'>
          <div className='row'>
            <div className='col pb-3'>
              <Reactcalendar locale="ja-JP" calendarType="US"
                onChange={changeDate}
                onActiveStartDateChange={changeStartDate}
                minDate={new Date(book_start)}
                value={selectDate}
                tileContent={getTileContent}
                tileClassName={getTileClass}
                className="w-100"
              />
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              {csvData &&
                <CSVLink className="w-100 btn btn-active mb-1 px-4 py-3" data={csvData.list} headers={csvData.header} filename={`${settings && settings.TITLE_SHORT_NAME ? settings.TITLE_SHORT_NAME : '予約'}${moment(selectDate).format('YYYYMM')}.csv`}>
                  {moment(selectDate).format('YYYY年MM月')}カレンダー設定<br />CSVダウンロード
                </CSVLink>
              }
            </div>
          </div>
        </div>
        <div className='col-8'>
          <div className='row'>
            <div className='col upload-csv-file-area'>
              <CSVReader
                ref={uploadButtonRef}
                disabled={disabled}
                onDrop={handleOnDrop}
                onError={handleOnError}
                addRemoveButton
                onRemoveFile={handleOnRemoveFile}
                config={{ encoding: "shift-jis" }}
              >
                <span>カレンダー設定CSVファイルを選択してください</span>
              </CSVReader>
            </div>
          </div>
          <div className='row'>
            <div className='col text-center p-3'>
              {uploadFile.minDate !== null &&
                <React.Fragment>
                  <h4>更新対象期間：{moment(uploadFile.minDate).format('YYYY/MM/DD')}～{moment(uploadFile.maxDate).format('YYYY/MM/DD')}</h4>
                  <div><button
                    disabled={disabled}
                    className='btn btn-active w-50'
                    onClick={submit}
                  >登録</button>
                  </div>
                </React.Fragment>
              }
            </div>
          </div>

          <div className='row'>
            <div className='col'>
              {selectDate &&
                <div className='row py-3'>
                  <div className='col'><h5>{moment(selectDate).format('YYYY/MM/DD')}</h5></div>
                </div>
              }
              {(selectDate && calendarMasterList.findIndex(x => moment(x.book_date).format('YYYYMMDD') === moment(selectDate).format('YYYYMMDD')) < 0) &&
                <div className='row'>
                  <div className='col'>
                    カレンダーは登録されていません
                  </div>
                </div>
              }
              {(selectDate && calendarMasterList.findIndex(x => moment(x.book_date).format('YYYYMMDD') === moment(selectDate).format('YYYYMMDD')) >= 0) &&
                <div className='row'>
                  <div className='col-12'>
                    <table className='w-100 table-striped text-center'>
                      <thead className='thead-light'>
                        <tr>
                          <th>ID</th>
                          <th>カテゴリ</th>
                          <th>開始時刻</th>
                          <th>終了時刻</th>
                          <th>受付数</th>
                          <th>備考</th>
                          <th>税抜き単価</th>
                          <th>税込み単価</th>
                          <th>税率</th>
                        </tr>
                      </thead>
                      <tbody>
                        {calendarMasterList.filter(x => moment(x.book_date).format('YYYYMMDD') === moment(selectDate).format('YYYYMMDD')).map((item, idx) =>
                        (
                          <tr key={idx}>
                            <td>
                              {item.book_set_id}
                            </td>
                            <td>
                              {item.category_name}
                            </td>
                            <td>
                              {CommonBooking.strTotime(item.start_time)}
                            </td>
                            <td>
                              {CommonBooking.strTotime(item.end_time)}
                            </td>
                            <td>
                              {item.book_count}({item.booked_count})
                            </td>
                            <td>
                              {Common.getBrString(item.remarks)}
                            </td>
                            <td>
                              {item.price_before_tax}
                            </td>
                            <td>
                              {item.price}
                            </td>
                            <td>
                              {item.tax_rate}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              }</div>
          </div>
        </div>
      </div>
      {disabled && <Loading />}
    </div>
  );
}

export default Calendar